module.exports = __webpack_public_path__ + "static/media/B5.55f89f33.jpg";